import { get as getConstants } from '@lumapps/constants';
import { getWebviewContentViewRoute } from '@lumapps/content-webview/routes';
import { isMediaUrl } from '@lumapps/medias/utils';
import { Route, isExternalUrl } from '@lumapps/router';
import { AppId } from '@lumapps/router/constants';

import { contentView } from '../../routes';
import { ContentLinkRef } from '../../types';

const { isLegacyContext, isMobileAppWebViewWithinWebComponents } = getConstants();

/**
 * Generate link props for content link.
 */
export function getContentLinkProps(
    to: ContentLinkRef,
    options: {
        isLayoutOn: boolean;
        isReactUserDirectoryEnabled?: boolean;
        displayContentInChildSite: boolean;
        currentInstanceParentId?: string;
    },
    createUrl: (route: Route) => string,
) {
    // Generate content link URL.
    const contentRoute = isMobileAppWebViewWithinWebComponents
        ? getWebviewContentViewRoute(to.id as string, to.instance?.slug)
        : contentView({
              to,
              isLayoutEnabled: options.isLayoutOn,
              isReactUserDirectoryEnabled: options.isReactUserDirectoryEnabled,
              displayContentInChildSite: options.displayContentInChildSite,
              currentInstanceParentId: options.currentInstanceParentId,
          });
    const href = contentRoute.appId === AppId.external ? contentRoute.path : createUrl(contentRoute);

    let target;

    /**
     * If the content is `external` and used as a redirection, open with _blank
     * — for truly external (absolute) URLs and relative media URLs (e.g. /serve/…).
     * Other relative URLs stay in the same tab.
     * else If link is on another instance or we're leaving the Legacy app, open with _self to force reload
     * */
    if (contentRoute.appId === AppId.external && (isExternalUrl(href) || isMediaUrl(href))) {
        target = '_blank';
    } else if ((contentRoute.appId !== AppId.legacy && isLegacyContext) || contentRoute.instanceSlug) {
        target = '_self';
    }

    return { href, target };
}
